import React from 'react'
import {FlatButton, Dialog, TextField, DatePicker, SelectField, MenuItem} from 'material-ui'
import {Form, FormRow, FormField, FormTitle} from './StyledComponents'
import { MANAGE_PROCUREMENTS } from '../routes'
import validator from "validator"
import moment from 'moment'

class ProcurementDialog extends React.Component {

	constructor(props) {
		super(props);
		const id = this.props.match.params.id
		let procurement = {
			project: '',
			pr_num: '',
			category: 'itb-sv',
			date: null,
			post_until: null,
			file: ''
		};
		if(id != undefined) {
			procurement = this.props.procurements.find((p) => p.id === id);
		}
		this.state = {
			project: {
				value: procurement.project,
				errorText: ''
			},
			pr_number: {
				value: procurement.pr_num,
				errorText: ''
			},
			category: {
				value: procurement.category,
				errorText: ''
			},
			date: {
				value: procurement.date ? moment(procurement.data).toDate() : new Date(),
				errorText: ''
			},
			post_until: {
				value: procurement.post_until ? moment(procurement.post_until).toDate() : moment().subtract(1, 'days').toDate(),
				errorText: ''
			},
			file: {
				value: procurement.file,
				file: null,
				errorText: ''
			}
		}
	}

	handleInputChange = (event, value) => {
		const target = event.target;
		const name = target.name;
		var errorText = this.validate(name, value);
		this.setState({
			[name]: {value: value, errorText: errorText}
		});
	}

	handleFileChange = (event, value) => {
		console.log(event.target.files[0])
		console.log(value)
		this.setState({file: {value: value, file: event.target.files[0], errorText: ''}})
	}

	handleTypeChange = (event, index, value) => {
		var errorText = this.validate('category', value);
		this.setState({category: {value: value, errorText: errorText}})
	}

	handleDateChange = (unknown, date) => {
		this.setState({date: {value: date, errorText: ''}})
	}

	handlePostUntilChange = (unknown, date) => {
		this.setState({post_until: {value: date, errorText: ''}})
	}

	validate = (fieldName, value) => {
		if(fieldName === 'project') {
			if(validator.isEmpty(value)) {
				return 'This field is required.';
			}
		}
		if(fieldName === 'pr_number') {
			if(validator.isEmpty(value)) {
				return 'This field is required.';
			}
		}
		else if(fieldName === 'category') {
			if(validator.isEmpty(value)) {
				return 'This field is required.';
			}
		}
		else if(fieldName === 'date') {
			if(value === null) {
				return 'This field is required.';
			}
		}
		else if(fieldName === 'post_until') {
			if(value === null) {
				return 'This field is required.';
			}
		}
		else if(fieldName === 'file') {
			if(value === '') {
				return 'This field is required.';
			}
		}
		return '';
	}

	render() {
		const {onClick, history, dialogTitle} = this.props
		const actions = [
			<FlatButton
				label="Cancel"
				onTouchTap={() => {
					history.push(MANAGE_PROCUREMENTS)
				}}
			/>,
			<FlatButton
				label="Save"
				primary={true}
				onTouchTap={() => {
					let data = {
						project: this.state.project.value,
						pr_number: this.state.pr_number.value,
						category: this.state.category.value,
						date: this.state.date.value,
						post_until: this.state.post_until.value,
						file: this.state.file.file
					}
					let hasError = false;
					for (var property in data) {
						if (data.hasOwnProperty(property)) {
							var errorText = this.validate(property, data[property]);
							if(errorText !== '') {
								hasError = true;
								this.setState({
									[property]: {value: data[property], errorText: errorText}
								});
								break;
							}
						}
					}
					if(hasError === false) {
						const id = this.props.match.params.id
						onClick(data, id)
						history.push(MANAGE_PROCUREMENTS)
					}
				}}
			/>
		];
		return (
			<Dialog 
				title={dialogTitle}
				actions={actions}
				modal={true}
				open={true}
				autoScrollBodyContent={true}>
				<Form>
				<FormRow>
					<FormField width="100%">
					<TextField name="project" floatingLabelText="Project"
						value={this.state.project.value}
						errorText={this.state.project.errorText}
						onChange={this.handleInputChange}
						autoFocus={true}
						floatingLabelFixed={true}
						fullWidth={true}
						/>
					</FormField>
				</FormRow>
				<FormRow>
					<FormField width="50%">
					<TextField name="pr_number" floatingLabelText="PR Number"
						value={this.state.pr_number.value}
						errorText={this.state.pr_number.errorText}
						onChange={this.handleInputChange}
						floatingLabelFixed={true}
						/>
					</FormField>
					<FormField width="50%">
					<SelectField
						floatingLabelText="Category"
						floatingLabelFixed={true}
						value={this.state.category.value}
						errorText={this.state.category.errorText}
						onChange={this.handleTypeChange}
							>
								<MenuItem value="itb-sv" primaryText="Invitation To Bid (Small Value)" />
								<MenuItem value="itb-shopping" primaryText="Invitation To Bid (Shopping)" />
								<MenuItem value="itb-pb" primaryText="Invitation To Bid(Public Bidding)" />
								<MenuItem value="bdb" primaryText="Bid Bulletin" />
								<MenuItem value="noa-pb" primaryText="Notice of Awards(Public Bidding)" />
								<MenuItem value="noa-svp" primaryText="Notice of Awards(Small Value Procurement)" />
								<MenuItem value="noa-shopping" primaryText="Notice of Awards(Shopping)" />
								<MenuItem value="noa-dc" primaryText="Notice of Awards(Direct Contracting)" />
								<MenuItem value="noa-ro" primaryText="Notice of Awards(Repeat Order)" />
								<MenuItem value="noa-ec" primaryText="Notice of Awards(Emergency Cases)" />
								<MenuItem value="contracts" primaryText="Contracts" />
								<MenuItem value="ntp-cw" primaryText="Notice to Proceed And Commence Work" />
								<MenuItem value="resolutions" primaryText="Minutes of the Pre-Bid Conference" />
						</SelectField>
					</FormField>
				</FormRow>
				<FormRow>
					<FormField width="50%">
					<DatePicker 
						value= {this.state.date.value}
						errorText= {this.state.date.errorText}
						name="date" floatingLabelText="Date"
						onChange={this.handleDateChange}
						floatingLabelFixed={true}
						fullWidth={true}/>
					</FormField>
					<FormField width="50%">
					<DatePicker 
						value= {this.state.post_until.value}
						errorText= {this.state.post_until.errorText}
						name="post_until" floatingLabelText="Post Until(For Announcement)"
						onChange={this.handlePostUntilChange}
						floatingLabelFixed={true}
						fullWidth={true}/>
					</FormField>
				</FormRow>
				<FormRow>
					<FormField width="100%">
					<TextField name="file" 
						value={this.state.file.value}
						errorText={this.state.file.errorText}
						onChange={this.handleFileChange}
						fullWidth={true}
						type="file"
						accept="application/pdf"
						/>
					</FormField>
				</FormRow>
				</Form>
			</Dialog>
		)
	}
}

export default ProcurementDialog


// WEBPACK FOOTER //
// ./src/components/ProcurementDialog.js